import React from 'react';
import SliderWords from '../SliderWords';
import { useTranslation } from 'react-i18next';
import './bannerAccion.css';

function BannerAccion() {

const { t } = useTranslation();

  return (
    <>
    <section className='sec--area banner-accion'>
      <div className="container">
        <div className='row d_flex align-items-center justify-content-center'>
          <div className='col-lg-6'>
              <figure className="banner--img" >
                  <img src={require (`img/talento-tecnologico.png` )} width="100%" alt="Customers Stories DreamCode Software" loading="lazy" />               
              </figure>
          </div>
          <div className='col-lg-6 '>
              <h3 className='w_color f_700'>
                {t("banner_accion.title")}
              </h3>
              <p className='w_color f_400'>{t("banner_accion.sub_title")}</p>
          </div>
        </div>

      </div>
    </section>
    <section className='banner-btn'>
      <div className='container'>
        <div className='row d_flex align-items-center justify-content-center'>
            <div className='col-lg-8 text-left'>
              <h3 className='w_color'>{t("banner_accion.banner_blue")}</h3>
              <SliderWords />
            </div>
            <div className='col-lg-4 btn-agendar'>
              <a href='#Formulario' className=''>{t("form_booking_btn")}</a>
            </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default BannerAccion;